module.exports = __webpack_public_path__ + "static/dev-46d9f22baccdf7718ee608f0b5503c6c.svg";